import '../styles/underwater_bg.css';

export default function UnderwaterBackground({ className = "", staticMode = false }) {
  const combinedClassName = `underwater-bg${staticMode ? " publish-static" : ""}${className ? ` ${className}` : ""}`;

  return (
    <div className={combinedClassName}>
      <div className="rays">
        {[...Array(8)].map((_, i) => <div key={i} className="ray" />)}
      </div>
      {[...Array(6)].map((_, i) => <div key={i} className="rock" />)}
      <div className="weed-container">
        {[...Array(8)].map((_, i) => <div key={i} className="weed" />)}
      </div>
      <div className="seabed" />
      <div className="bubbles">
        {[...Array(18)].map((_, i) => <div key={i} className="bubble" />)}
      </div>
      {[...Array(6)].map((_, i) => <div key={i} className="particle" />)}
      <div className="fog top" />
      <div className="fog bottom" />
    </div>
  );
}